import cn from "classnames";
import { FormikErrors } from "formik";
import React from "react";

export const FormField = ({
  id,
  error,
  children,
  label,
  className,
}: {
  id?: string;
  children: React.ReactElement;
  label?: string | React.ReactNode;
  error?:
    | string
    | string[]
    | FormikErrors<any>
    | FormikErrors<any>[]
    | undefined;
  className?: string;
}) => {
  return (
    <div className={cn("relative mb-8", className)}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <div className="">
        {React.cloneElement(children, { error: error ? true : undefined })}
      </div>
      <div
        className={cn(
          "absolute mt-1 text-red-500 text-xs transition-opacity",
          error ? "opacity-100" : "opacity-0"
        )}
      >
        {error}
      </div>
    </div>
  );
};

export const Label = React.memo(
  ({
    children,
    className,
    ...props
  }: React.ComponentProps<"label"> & {
    children: React.ReactNode;
    className?: string;
  }) => {
    return (
      <label
        className={cn("text-sm text-gray-800 mb-1 block", className)}
        {...props}
      >
        {children}
      </label>
    );
  }
);

export const FormError = React.memo(
  ({
    children,
    className,
    marginClassName = "mb-2",
    ...props
  }: React.ComponentProps<"div"> & {
    children: React.ReactNode;
    className?: string;
    marginClassName?: string;
  }) => {
    return (
      <div
        className={cn("text-red-500 text-sm", marginClassName, className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);
